module.exports = __webpack_public_path__ + "img/hero-sofrigam.f9e71c1f.jpg";